
export interface IHeroLanguageData {
    code: string;
    name: string;
    native: string;
};

export const languageData : IHeroLanguageData[] = [{
    code: 'de',
    name: 'german',
    native: 'deutsch'
}, {
    code: 'en',
    name: 'english',
    native: 'english'
}, {
    code: 'fr',
    name: 'french',
    native: 'français'
}, {
    code: 'it',
    name: 'italian',
    native: 'italiano'
}, {
    code: 'es',
    name: 'spanish',
    native: 'español'
}, {
    code: 'pt',
    name: 'portuguese',
    native: 'português'
}, {
    code: 'nl',
    name: 'dutch',
    native: 'nederlands'
}, {
    code: 'pl',
    name: 'polish',
    native: 'polski'
}];